<script lang="ts">
  import type { TSearchListItem } from "../types/webcomponent.type";

  function tagModifier(color: string | undefined): string {
    const c = color || "secondary";
    if (c === "secondary") return "is-light";
    return `is-${c}`;
  }

  let {
    id = "",
    is_inpput,
    url,
    icon,
    text,
    number_of_results,
    badge,
    input_search,
    clicksearch,
  }: TSearchListItem & {
    is_inpput: boolean;
    input_search: string;
    clicksearch: (text: string, id?: string) => Promise<void>;
  } = $props();
</script>

{#if url}
  <a
    href={url}
    class="hb-searchbar-row"
    onclick={async () => {
      await clicksearch(text, id);
    }}
  >
    {#if icon}
      <i class={`bi bi-${icon ? icon : "dot"}`}></i>
    {/if}

    <span class="is-flex-grow-1">{is_inpput ? "... " : ""}{text}</span>
    {#if number_of_results || number_of_results === 0}
      <span class="results_number">
        {number_of_results} Results
      </span>
    {/if}
    {#if badge}
      <span class={`tag ${tagModifier(badge.color)} is-flex is-align-items-center is-gap-1`}>
        {#if badge.icon}
          <i class={`bi bi-${badge.icon}`}></i>
        {/if}
        {badge.text}
      </span>
    {/if}
  </a>
{:else}
  <button
    type="button"
    class="hb-searchbar-row"
    onclick={async () => {
      await clicksearch(text, id);
    }}
  >
    {#if icon}
      <i class={`bi bi-${icon ? icon : "dot"}`}></i>
    {/if}
    <span class="is-flex-grow-1">{is_inpput ? "... " : ""}{text}</span>
    {#if number_of_results}
      <span class="results_number">
        {number_of_results} Results
      </span>
    {/if}
    {#if badge}
      <span class={`tag ${tagModifier(badge.color)} is-flex is-align-items-center is-gap-1`}>
        {#if badge.icon}
          <i class={`bi bi-${badge.icon}`}></i>
        {/if}
        {badge.text}
      </span>
    {/if}
  </button>
{/if}

<style lang="scss">
  @forward "../styles/bulma.scss";
  @use "../styles/searchbar-row.scss";
</style>
